/** API がこの URL を返す場合は public のローカル画像を使う（CORS/帯域の都合など） */
const REMOTE_DEFAULT_CHILD_ICON_URL =
  'https://chaild-dev-public-139294833390-sg/public/user_default_icon.png';
const LOCAL_DEFAULT_CHILD_ICON = '/user_default_icon.png';

export function resolveChildImageUrl(imageUrl: string | undefined | null): string {
  if (!imageUrl) return '';
  if (imageUrl === REMOTE_DEFAULT_CHILD_ICON_URL) return LOCAL_DEFAULT_CHILD_ICON;
  return imageUrl;
}
